import React from 'react';
import { notification } from 'antd';
import {
  FormattedHTMLMessage,
  FormattedMessage,
  IntlProvider,
} from 'react-intl';
import Pficon from 'components/Pficon';

const ICON_CLASS_NAMES = {
  danger: 'vertical-align-top margin-right-xxs',
  'warning-boxed':
    'vertical-align-top margin-right-xxs text-size-secondary color-red-6',
  info: 'vertical-align-top margin-right-xxs text-size-secondary color-blue-6',
  success:
    'vertical-align-top margin-right-xxs text-size-secondary color-green-6',
};

function renderTitle({ titleMessage, titleValues, iconType }) {
  return (
    <div className="color-red-6 text-size-primary">
      {iconType && (
        <Pficon type={iconType} className={ICON_CLASS_NAMES[iconType]} />
      )}
      <IntlProvider>
        <FormattedMessage {...titleMessage} values={titleValues} />
      </IntlProvider>
    </div>
  );
}

function renderDescription({
  descriptionMessage,
  descriptionValues,
  descriptionIsHtml,
}) {
  const DescriptionComponent = descriptionIsHtml
    ? FormattedHTMLMessage
    : FormattedMessage;

  return (
    <IntlProvider>
      <DescriptionComponent
        {...descriptionMessage}
        values={descriptionValues}
      />
    </IntlProvider>
  );
}

export function openNotification({
  key,
  duration = 3,
  className,
  titleMessage,
  titleValues,
  descriptionMessage,
  descriptionValues,
  descriptionIsHtml = false,
  iconType,
  placement = 'topRight',
}) {
  notification.close({ key });

  notification.open({
    key,
    placement,
    duration,
    className,
    closeIcon: <Pficon type="close" />,
    message: renderTitle({
      titleMessage,
      titleValues,
      iconType,
    }),
    description:
      descriptionMessage &&
      renderDescription({
        descriptionMessage,
        descriptionValues,
        descriptionIsHtml,
      }),
  });
}

export default openNotification;
